import Actions from '../../odata/actions';

const actions = new Actions('jobListingCandidateTask', 'jobListingCandidateTasks');

export default actions;
